// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"DocsTable_downloadBtn__1cBRt","uploadBtn":"DocsTable_uploadBtn__34rwI","myGrid":"DocsTable_myGrid__39jy5","myGrid2":"DocsTable_myGrid2__wDlE8"};